import React from 'react';

const AppContext = React.createContext({
    displayNftSearch: false,
    displayBrandCampaign: false
});

export default AppContext;
